import type { AppRouteRecordRaw } from "@/types/router";
import { LAYOUT } from "@/router/constants";

const reportingItems: AppRouteRecordRaw = {
  path: "/reporting_items",
  name: "ReportingItems",
  redirect: "/reporting_items/list",
  component: LAYOUT,
  meta: {
    title: "提报项管理",
  },

  children: [
    {
      path: "list",
      name: "ReportingItemsList",
      component: () => import("@/views/alliance/reporting-items/index.vue"),
      meta: {
        title: "提报项管理",
      },
    },
  ],
};

export default reportingItems;
